// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { ShiftPattern, NewShiftPattern } from "@modules/service/reducer/shift-patterns/types";

type OwnProps = $Exact<{
  clientId: ?number,
  data: ShiftPattern | NewShiftPattern,
}>;

type PropsFromDispatch = $Exact<{
  setShowDeleteModal: typeof actionCreators.ShowDeleteShiftPatternModal,
  deleteShiftPattern: typeof actionCreators.DeleteShiftPattern,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...PropsFromDispatch,
}>;

export class ShiftPatternDeleteModal extends React.Component<Props> {
  handleCancel = () => {
    this.props.setShowDeleteModal(false);
  };

  handleSubmit = () => {
    this.props.data &&
      this.props.data.id &&
      this.props.deleteShiftPattern({ clientId: this.props.clientId, id: this.props.data.id });
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader className="d-flex justify-content-between" toggle={this.handleCancel}>
          {this.props.t("SHIFT_PATTERN_DELETE_TITLE")}
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-start align-content-center">
          <p className="text-greyish-brown">
            {this.props.t("SHIFT_PATTERN_DELETE_QUESTION", {
              shiftName: (this.props.data && this.props.data.name) || "",
            })}
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button color="negative" onClick={this.handleSubmit}>
            {this.props.t("DELETE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps: PropsFromDispatch = {
  setShowDeleteModal: actionCreators.ShowDeleteShiftPatternModal,
  deleteShiftPattern: actionCreators.DeleteShiftPattern,
};

export default compose(localize(), connect(null, mapDispatchToProps))(ShiftPatternDeleteModal);
